import { FC, ReactNode } from 'react';

import { CompanyProfile } from 'models';

import { IKImage, IKImageProps } from 'components/ik-image/IKImage';
import { useFile } from 'hooks/use-file';

const CompanyLogo: FC<
    Pick<IKImageProps, 'loading' | 'fetchPriority'> & {
        logos: CompanyProfile['logos'];
        width?: number;
        height?: number;
        squareWidth?: number;
        adjustWidth?: boolean;
        fallback?: ReactNode;
    }
> = ({ logos, width, squareWidth, height, adjustWidth, fallback, loading, fetchPriority }) => {
    const logo = logos.small || logos.large;

    const { file, isLoading } = useFile(logo);

    const aspectRatio = (file?.height ?? 1) / (file?.width ?? 1);

    if (height && !width) {
        width = height / aspectRatio;
    }

    let widthMultiplier = 1;

    if (adjustWidth) {
        if (aspectRatio < 0.35) widthMultiplier = 1.3;
        if (aspectRatio > 0.9 && aspectRatio < 1.1) widthMultiplier = 0.7;
    }

    if (squareWidth && aspectRatio === 1) {
        width = squareWidth;
        height = squareWidth;
    }

    return file || isLoading ? (
        <IKImage
            disableCrop
            fileOrId={file}
            width={width ? width * widthMultiplier : 200}
            height={height}
            style={{
                objectFit: 'contain',
                width: width ? width * widthMultiplier : 200,
                height,
            }}
            loading={loading}
            fetchPriority={fetchPriority}
            alt=""
        />
    ) : (
        <>{fallback}</>
    );
};

export { CompanyLogo };
